import { useCallback } from 'react';

export const usePaginationModelChange = ({
  page,
  pageSize,
  nextPage,
  defaultPageSize,
}) => {
  const handlePaginationModelChange = useCallback(
    (newPaginationModel) => {
      const { page: newPage, pageSize: newPageSize } = newPaginationModel;

      if (!nextPage) return;

      if (newPage !== page - 1) {
        nextPage(newPage + 1, pageSize || defaultPageSize);
      }

      if (newPageSize !== (pageSize || defaultPageSize)) {
        nextPage(1, newPageSize);
      }
    },
    [page, pageSize, nextPage, defaultPageSize]
  );

  return handlePaginationModelChange;
};
